import { MyAccountEmptyStateMyBTConstants } from "@pages/MyAccount/utils/constants";

export default function MyAccountPopoverMyBTEmptyState(): React.ReactElement {
  return (
    <div
      data-testid="my-account-myBT-empty-state-component"
      className="text-center"
    >
      <img
        src={MyAccountEmptyStateMyBTConstants.src}
        alt="my account myBT"
        width={180}
        height={170}
        className="mx-auto mb-8 mt-10"
      />

      <div className="mb-4">
        <p className="font-xs mb-0 font-public-sans text-gray-850">
          {MyAccountEmptyStateMyBTConstants.afterLoginDescription}
        </p>
      </div>
    </div>
  );
}
